import React, { useEffect, useState } from 'react'
import { useBnsGoodsListQuery } from '../../store/BnsKeJiApi';
import { Select,Form} from 'antd';

function ProjectSelect(props) {
    const [list, setList] = useState();    
    const {data, isSuccess} = useBnsGoodsListQuery({bg_e_id:localStorage.getItem('e_id')},{refetchOnMountOrArgChange:1});    
    useEffect(() => {
        if (isSuccess) {
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {bg_id:key,bg_name,bg_dept_id,bg_dept_name} = item;
                    return item = {value:key,label:bg_name,bg_dept_id,bg_dept_name,}
                })                
                setList(newArr)
            }else{
                setList([])
            }
            
        }
    }, [data, isSuccess])
    return (
        <Form.Item
            label={props.label}
            name={props.name}
            wrapperCol={props.wrapperCol}
            required={props.required}
            style={props.FormStyle}
        >
            <Select
                options={list}
                onChange={(e,f) => {
                    props.onChange(e,f)
                }}
                placeholder={props.placeholder}
                allowClear
                onClear={props.onClear}
                style={props.style}
            />
        </Form.Item>
    )
}

export default ProjectSelect